import Faqs from "./Faqs.page";

export default Faqs;